// free-product-logic.js (ENHANCED VERSION with Multiple Thresholds)

document.addEventListener('DOMContentLoaded', function() {
    // Define your gift tiers - add or modify as needed
    const GIFT_TIERS = [
        // {
        //     threshold: 2000,
        //     products: [
        //         { variantId: 51596325093690, name: 'Free Gift 1 (Rs.2000)' },
        //         { variantId: 51596329124154, name: 'Free Gift 2 (Rs.2000)' }
        //     ]
        // },
        {
            threshold: 7000,
            products: [
                { variantId: 52099643703610, name: 'Free Gift (Rs.7000)' } // <<< REPLACE WITH YOUR ACTUAL VARIANT ID
            ]
        },
        {
            threshold: 10000,
            products: [
                { variantId: 52099655237946, name: 'Free Gift (Rs.10000)' } // <<< REPLACE WITH YOUR ACTUAL VARIANT ID
            ]
        }
    ];

    const FREE_GIFT_PROPERTY_KEY = '_free_gift';
    const FREE_GIFT_PROPERTY_VALUE = 'true';

    /*
     * Helper to trigger Dawn theme's native cart UI refreshes.
     */
    function triggerDawnCartRefresh() {
        console.log('Attempting to trigger Dawn theme cart UI refresh...');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-product-logic' });
        } else {
            console.warn('Dawn theme pub/sub not found. Falling back to general refresh events.');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
        }
    }

    /*
     * Fetches the current cart data using Shopify's AJAX API.
     */
    async function getCart() {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }

    /*
     * Adds products to the cart with a special property to mark them as free gifts.
     */
    async function addItemsToCart(items) {
        if (items.length === 0) {
            return null;
        }

        const itemsWithProperties = items.map(item => ({
            ...item,
            properties: {
                ...item.properties,
                [FREE_GIFT_PROPERTY_KEY]: FREE_GIFT_PROPERTY_VALUE
            }
        }));

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items: itemsWithProperties })
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error adding items to cart:', error);
            return null;
        }
    }

    /*
     * Removes specified free gift products from the cart.
     */
    async function removeFreeProducts(variantIdsToRemove) {
        const cart = await getCart();
        if (!cart) {
            return;
        }

        const itemsToRemove = {};
        let removalNeeded = false;

        cart.items.forEach(item => {
            const isFreeGiftProduct = variantIdsToRemove.includes(item.variant_id);
            const hasFreeGiftProperty = item.properties && item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;

            if (isFreeGiftProduct && hasFreeGiftProperty) {
                itemsToRemove[item.key] = 0;
                removalNeeded = true;
            }
        });

        if (removalNeeded) {
            console.log('Removing ineligible free products:', itemsToRemove);
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ updates: itemsToRemove })
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(`HTTP error! status: ${response.status}, message: ${errorData.message || 'Unknown error'}`);
                }
                await response.json();
                console.log('Free products removed successfully.');
                triggerDawnCartRefresh();
            } catch (error) {
                console.error('Error removing items from cart:', error);
            }
        }
    }

    /*
     * Main logic: Checks cart and manages free products based on thresholds.
     */
    async function checkAndManageFreeProducts() {
        const cart = await getCart();

        if (!cart) {
            return;
        }

        const cartTotalPrice = cart.total_price / 100; // Convert from cents to currency

        // Determine which tiers are eligible based on cart total
        const eligibleTiers = GIFT_TIERS.filter(tier => cartTotalPrice >= tier.threshold);
        
        // Get all variant IDs that should be in the cart
        const eligibleVariantIds = [];
        eligibleTiers.forEach(tier => {
            tier.products.forEach(product => {
                eligibleVariantIds.push(product.variantId);
            });
        });

        // Get all possible free gift variant IDs (for removal check)
        const allGiftVariantIds = [];
        GIFT_TIERS.forEach(tier => {
            tier.products.forEach(product => {
                allGiftVariantIds.push(product.variantId);
            });
        });

        // Check what's currently in cart (with free_gift property)
        const currentFreeGiftVariantIds = [];
        cart.items.forEach(item => {
            const hasFreeGiftProperty = item.properties && item.properties[FREE_GIFT_PROPERTY_KEY] === FREE_GIFT_PROPERTY_VALUE;
            if (hasFreeGiftProperty && allGiftVariantIds.includes(item.variant_id)) {
                currentFreeGiftVariantIds.push(item.variant_id);
            }
        });

        // Determine what to add
        const itemsToAdd = [];
        eligibleVariantIds.forEach(variantId => {
            if (!currentFreeGiftVariantIds.includes(variantId)) {
                itemsToAdd.push({ id: variantId, quantity: 1 });
            }
        });

        // Determine what to remove (gifts that are no longer eligible)
        const variantIdsToRemove = currentFreeGiftVariantIds.filter(
            variantId => !eligibleVariantIds.includes(variantId)
        );

        // Execute removals first
        if (variantIdsToRemove.length > 0) {
            await removeFreeProducts(variantIdsToRemove);
        }

        // Then execute additions
        if (itemsToAdd.length > 0) {
            console.log(`Cart total: Rs.${cartTotalPrice}. Adding free products:`, itemsToAdd);
            const updatedCart = await addItemsToCart(itemsToAdd);

            if (updatedCart) {
                console.log('Free products added successfully.');
                triggerDawnCartRefresh();
            }
        }
    }

    // --- Event Listeners ---

    // 1. On initial page load
    checkAndManageFreeProducts();

    // 2. Listen for 'Add to Cart' form submissions
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
    addToCartForms.forEach(form => {
        form.removeEventListener('submit', handleFormSubmission);
        form.addEventListener('submit', handleFormSubmission);
    });

    function handleFormSubmission() {
        setTimeout(checkAndManageFreeProducts, 300);
    }

    // 3. Listen for Dawn theme's native cart update event
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source !== 'free-product-logic') {
                setTimeout(checkAndManageFreeProducts, 100);
            }
        });
    } else {
        console.warn('Dawn theme pub/sub (subscribe) not found for listening to cart updates.');
    }

    // 4. Listen for drawer open/close events
    document.addEventListener('drawer:open', function(event) {
        if (event.detail && (event.detail.id === 'CartDrawer' || event.detail.id === 'MiniCart' || event.target.classList.contains('cart-drawer'))) {
            setTimeout(checkAndManageFreeProducts, 100);
        }
    });
});